// extracted by mini-css-extract-plugin
module.exports = {"output":"Output_output__1fJgL","error":"Output_error__1O_Kj","input":"Output_input__3VUJf"};